<section class="jumbotron">
  <div class="jumbotron-content text-white text-center">
    <h1 class="font-weight-bolder text-title-header">InventAIRy XL</h1>
    <span class="italic-title italic-title--small"><i>¿Listo para llevar la gestión de su inventario al siguiente nivel? RAWview y qAIRa transforman el control de inventario con esta solución para enfrentar desafíos críticos del sector logístico.</i> </span> <br>
  </div>
</section>
<section class="bg-green-qaira">
  <div class="container py-4 text-center text-white">
    <p class="p-subtitle text-center">InventAIRy XL combina un dron con tecnología de escaneado de códigos de barras
      incorporado y un vehículo guiado automatizado (AGV) construido específicamente para
      la navegación segura y totalmente autónoma del sistema y el procesamiento de datos.</p>
  </div>
</section>
<section class="bg-rawview-description">
  <div class="container">
    <div class="q-description">
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Componentes fiables</h5>
          <p>Más de 5 horas de duración de la batería con uso continuo</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Navegación autónoma</h5>
          <p>Carga de batería del sistema a un 80% en solo 3 horas.</p>
        </div>
      </div>
      <div class="media">
        <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" width="50" height="50" class="mr-3" alt="...">
        <div class="media-body">
          <h5 class="mt-0">Adquisición automática de datos</h5>
          <p>El sistema puede visitar hasta 400 posiciones de tarimas en 1 hora.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="bg-rawview-logo">
  <div class="container">
    <div class="q-logo">
      <div><img width="300"
          srcset="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_logo@2x.png, ../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_logo@2x.png 2x"
          src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_logo@2x.png" alt="Qaira y Rawview"></div>
      <div><img width="300"
          srcset="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_view_logo.png, ../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_view_logo@2x.png 2x"
          src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/qaira_raw_view_logo.png" alt="Qaira y Rawview"></div>
    </div>
  </div>
  <div class="q-franja">
    <div class="container">
      <p>¿Está listo para <strong>llevar la gestión de su inventario</strong> al siguiente nivel?</p>
    </div>
  </div>
</section>
<section class="q-bg-split">  
</section>
<section>
  <div class="text-center">
    <a href="../../../../assets/Brochures/Brochure Inventary XL.pdf" target="_blank" class="btn custom-cta bg-yellow-qaira custom-cta--padding custom-cta--padding--lg" >Conoce más aquí</a>
  </div>
</section>
<section class="section-land">
  <div class="container text-center text-white">
    <h1 class="font-weight-bolder mb-5 mt-5">{{'contact_home.title' | translate}}</h1>
    <p class="mb-5">{{'contact_home.subtitle' | translate}}</p>
    <a [routerLink]="['/contacto']" class="btn custom-cta mb-5 custom-cta--padding">{{'app.contact_us' | translate}}</a>
  </div>
</section>